/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import { Button, Box, Grid, OutlinedAddon, OutlinedAdornment } from 'core/components/Core'
import TextField from 'core/components/TextField'
import Typography from 'core/components/Typography'
import { actionsUpload, useUpload } from '../context'
import ProductImageModal from './ProductImageModal'

const ProductImage = ({ onUploadComplete, className, label, onImageError }) => {
  const [isOpenPreview, onOpenPreview] = useReducer(bool => !bool, false)
  const [imageURL, setImageURL] = useState('')
  const [state, dispatch] = useUpload()
  const [buttonDisabled, setButtonDisabled] = useState(true)
  /**
   * Cria um objeto imagem.
   */
  const createImageFromUrl = url => {
    const image = new Image()
    image.src = url
    return image
  }

  /**
   * Dispatch para adicionar uma imagem no state.
   */
  const dispatchUploadImage = () => {
    const image = createImageFromUrl(imageURL)
    dispatch({
      type: actionsUpload.ADD_FILES,
      state: [
        {
          ...image,
          uploadStatus: 'waiting',
          name: imageURL,
          id: imageURL,
          url: imageURL,
          id_ref: imageURL,
          type: 'URL',
        },
      ],
    })
  }

  /**
   * Confirma o upload da imagem.
   */
  const onConfirmPreview = () => {
    onOpenPreview()
    dispatchUploadImage()
  }

  /**
   * Ciclo de vida do componente.
   */
  useEffect(() => {
    if (state.UPLOAD_STATUS === 'COMPLETED') {
      onUploadComplete(state.FILES)
      setImageURL('')
    }
  }, [state.UPLOAD_STATUS])

  const validateImageUrl = value => {
    const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}\/?.*\.(jpg|jpeg|png)(\?.*)?$/i
    const isAValidUrlImage = regex.test(value)
    setButtonDisabled(!isAValidUrlImage)

    if (isAValidUrlImage) {
      setImageURL(value)
    } else if (onImageError) {
      onImageError()
    }
  }

  return (
    <Box className={className}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {label ? (
            <Typography mb={1} fontSize="small" style={{ color: '#788089' }}>
              {label}
            </Typography>
          ) : (
            <>
              <Typography fontSize="medium" fontWeight="medium">
                {i18n.t('product.image')}
              </Typography>
              <Typography mb={2} fontSize="small">
                {i18n.t('product.productUpload.imageLinkSubtitle')}
              </Typography>
            </>
          )}

          <OutlinedAdornment position="end">
            <TextField
              fullWidth
              hiddenLabel
              name="image"
              onChange={event => validateImageUrl(event.target.value)}
              placeholder={i18n.t('product.imagePlaceholder')}
              value={imageURL}
            />
            <OutlinedAddon position="end" variant="search">
              <Button
                color="primary"
                disabled={buttonDisabled}
                fullWidth
                loading={state.UPLOAD_STATUS === 'IN_PROGRESS'}
                onClick={onOpenPreview}
                size="large"
                variant="contained"
              >
                <SearchIcon />
              </Button>
            </OutlinedAddon>
          </OutlinedAdornment>
        </Grid>
      </Grid>
      <ProductImageModal
        handleClose={onOpenPreview}
        handleConfirm={onConfirmPreview}
        imageLink={imageURL}
        isOpen={isOpenPreview}
      />
    </Box>
  )
}

ProductImage.propTypes = {
  onUploadComplete: PropTypes.func.isRequired,
}

export default ProductImage
